import {
  ADD_FARE,
  EDIT_FARE,
  UPDATE_FARE,
  DELETE_FARE,
  FETCH_ALL_FARE,
  FETCH_ALL_FARE_SUCCESS,
  FETCH_ALL_FARE_FAILED,
  CONFIRM_FARE,
  CONFIRM_FARE_SUCCESS,
  CONFIRM_FARE_FAILED,
  EDIT_FARE_SUCCESS,
  EDIT_FARE_FAILED,
  CLEAR_FARE
} from "../store/types";

export const INITIAL_STATE = {
  fare: null,
  active: null,
  loading: false,
  tracked: null,
  error: {
    flag: false,
    msg: null
  }
}

export const farereducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case CONFIRM_FARE:
      return {
        ...state,
        loading: true
      };
    case CONFIRM_FARE_SUCCESS:
      return {
        ...state,
        fare: action.payload,
        loading: false
      };
    case CONFIRM_FARE_FAILED:
      return {
        ...state,
        fare: null,
        loading: false,
        error: {
          flag: true,
          msg: action.payload
        }
      };
    case CLEAR_FARE:
      return INITIAL_STATE;
    case FETCH_ALL_FARE:
      return {
        ...state,
        loading: true
      };
    case FETCH_ALL_FARE_SUCCESS:
      return {
        ...state,
        fare: action.payload,
        loading: false
      };
    case FETCH_ALL_FARE_FAILED:
      return {
        ...state,
        fare: null,
        loading: false,
        error: {
          flag: true,
          msg: action.payload
        }
      };
    case UPDATE_FARE:
      return {
        ...state,
      };
    case EDIT_FARE:
      return {
        ...state,
      };
    case EDIT_FARE_SUCCESS:
      return {
        ...state,
        ...action.payload,
        loading: false,
        tracking: null
      }
    default:
      return state;
  }
};